import { j as r } from "../../../jsx-runtime-B3iL8JI7.js";
const n = (e) => {
  const { children: s } = e;
  return /* @__PURE__ */ r.jsx("span", { className: "sr-only", children: s });
};
export {
  n as default
};
